import { ParcelCountItem } from '../ParcelCountItem';
import type { TFunction } from 'i18next';

const LabelPrintingIconWithQuantity = ({
  qty,
  t,
  onSelect
}: {
  qty: number;
  t: TFunction<string, undefined>;
  onSelect?: () => void;
}) => <ParcelCountItem o={qty} t={t} alignment="row-reverse" onSelect={onSelect} />;

export default LabelPrintingIconWithQuantity;
